import React from "react";
import "../../assets/css/vendor.bundle.css";
import "../../assets/css/style.css";
import "../../assets/css/theme.css";
import Footer from "../common/Footer";
import Navbar from "../common/NavBar";
import { Helmet } from "react-helmet-async";

const Faqs = () => {
  return (
    <div>
      <Helmet>
        <title>FAQs</title>
      </Helmet>
      <div className="site-header header-s1 is-sticky">
        <Navbar />
        {/* Banner/Slider */}
        <div class="page-head section row-vm light has-bg-image">
          <div class="imagebg bg-image-loaded" style={{ backgroundImage: `url(${require('../../assets/images/page-inside-bg.jpg')})` }}>
            <img
              src={require("../../assets/images/page-inside-bg.jpg")}
              alt="page-head"
            />
          </div>
          <div class="container">
            <div class="row text-center">
              <div class="col-md-12">
                <h2>Frequent Questions</h2>
                <div class="page-breadcrumb">
                  <ul class="breadcrumb">
                    <li>
                      <a href="/">Home</a>
                    </li>
                    <li class="active">
                      <span>Frequent Questions</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* #end Banner/Slider */}
      </div>
      {/* Section */}
      <div className="section section-pad">
        <div className="container text-left">
          <div className="row">
            <div className="col-md-12">
              <h4>
                Frequently Asked <span>Questions</span>
              </h4>
              <div className="gaps size-1x"></div>
            </div>
          </div>
          <div className="faq-one row">
            <div className="col-md-6">
              <div className="single-faq mr-x2">
                <h5 className="faq-heading">Can anyone open an account with AFC Trades?</h5>
                <p>Yes! However, the individual has to be above 18 years old.</p>
              </div>
              <div className="gaps size-x2"></div>
            </div>
            <div className="col-md-6">
              <div className="single-faq mr-x2">
                <h5 className="faq-heading">How can I open an account with AFC Trades?</h5>
                <p>
                  It’s pretty easy! You can simply follow the registration steps and complete your trading account profile with the required information and the relative documents to verify your account.
                </p>
              </div>
              <div className="gaps size-x2"></div>
            </div>
            <div className="col-md-6">
              <div className="single-faq mr-x2">
                <h5 className="faq-heading">
                  What are the documents that are needed to verify the account or know your client (KYC)?
                </h5>
                <p>
                  The documents which are required will be:
                  <ul>
                    <li>Proof of Identity - National ID, government permitted documents or Passports.</li>
                    <li>
                      Proof of Address or Residence - Utility bills such as water or electricity bills under the respective individual's name stated in less than 6 months.
                    </li>
                    <li>Proof of Payment - Method and details of how the transaction was completed.</li>
                  </ul>
                </p>
              </div>
              <div className="gaps size-x2"></div>
            </div>
            <div className="col-md-6">
              <div className="single-faq mr-x2">
                <h5 className="faq-heading">What is the base currency used in AFC Trades?</h5>
                <p>US Dollars</p>
              </div>
              <div className="gaps size-x2"></div>
            </div>
            <div className="col-md-6">
              <div className="single-faq mr-x2">
                <h5 className="faq-heading">What is the minimum amount a client can deposit?</h5>
                <p>Clients can start their respective trading account with a minimum of 200 USD.</p>
              </div>
              <div className="gaps size-x2"></div>
            </div>
            <div className="col-md-6">
              <div className="single-faq mr-x2">
                <h5 className="faq-heading">How can clients deposit funds?</h5>
                <p>
                  Funds can be deposited to their respective trading account via wire transfer, e-wallets, visa, master, and maestro debit and credit cards. Alternative payment methods may be provided depending on your region.
                </p>
              </div>
              <div className="gaps size-x2"></div>
            </div>
            <div className="col-md-6">
              <div className="single-faq mr-x2">
                <h5 className="faq-heading">Will the client be receiving any leverage?</h5>
                <p>Yes, depending upon the account type and the instruments they are willing to trade in.</p>
              </div>
              <div className="gaps size-x2"></div>
            </div>
            <div className="col-md-6">
              <div className="single-faq mr-x2">
                <h5 className="faq-heading">What trading markets can the client trade with AFC Trades?</h5>
                <p>
                  Clients can trade in forex or currency, commodities, shares, stocks, indices, and cryptocurrency markets. Depending upon the investment or funds in their trading account, the client can choose the market of their own.
                </p>
              </div>
              <div className="gaps size-x2"></div>
            </div>
            <div className="col-md-6">
              <div className="single-faq mr-x2">
                <h5 className="faq-heading">
                  If the client transfers funds into their trading account in a different currency, what rate will it be converted at?
                </h5>
                <p>
                  If the client funds their respective trading account from a different currency, the client’s trading account will be converted to the base currency at the ongoing spot rate. It may apply a few additional charges as it may be required depending upon your region.
                </p>
              </div>
              <div className="gaps size-x2"></div>
            </div>
            <div className="col-md-6">
              <div className="single-faq mr-x2">
                <h5 className="faq-heading">
                  Does AFC Trades set a maximum transaction amount for a client to deposit/ transfer funds or withdrawal through VISA/ MASTERCARD?
                </h5>
                <p>
                  Yes, the maximum transaction amount the client can deposit or withdraw via VISA/MASTERCARD will be restricted to a total of $50,000. However, your debit or credit card may be set for an amount limitation by the acquired bank.
                </p>
              </div>
              <div className="gaps size-x2"></div>
            </div>
            <div className="col-md-6">
              <div className="single-faq mr-x2">
                <h5 className="faq-heading">
                  If deposits are completed via VISA/MASTERCARD, are any additional documents required?
                </h5>
                <p>
                  Yes, if capital or the fund is transferred via debit or credit card, we may require a scanned clear copy or a picture of your credit/debit card (front and back). The cardholder’s name, bank of issue, and expiry dates, along with the first six and last four digits of the card, should be visible on the scanned copy or picture taken through any device. It is important to note that the CVV number must be covered for the client’s safety before submitting the documents. The client can provide an alternative option by providing AFC Trades with a credit/debit card statement mentioning their credentials.
                </p>
              </div>
              <div className="gaps size-x2"></div>
            </div>
            <div className="col-md-6">
              <div className="single-faq mr-x2">
                <h5 className="faq-heading">What type of customer support does AFC Trades provide?</h5>
                <p>
                  AFC Trades offers 24/7 support via live chat service where experienced and dedicated agents offer guidance and support. Alternatively, we also offer a callback and email service which can be found on our webpage.
                </p>
              </div>
            </div>
          </div>

        </div>

      </div>
      {/* End Section */}

      <Footer />
    </div>
  );
};

export default Faqs;
